import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import AuthShell from '@/components/layout/AuthShell';
import AuthSplit, { AuthField, AuthInput, AuthSubmit } from '@/components/layout/AuthSplit';

const SAMPLE_ROWS = [
  { sev: 'critical', name: 'Ransomware affiliate · initial access', meta: 'Finance · North America', serial: 'SAMPLE-1' },
  { sev: 'high', name: 'Credential phishing · SaaS tenants', meta: 'Technology · Europe', serial: 'SAMPLE-2' },
  { sev: 'medium', name: 'MFA fatigue campaign', meta: 'Healthcare · Global', serial: 'SAMPLE-3' },
];

/** Where "Request access" lands: there is no public sign-up, accounts come from an invitation. */
export default function AccessInfo() {
  const navigate = useNavigate();
  const [link, setLink] = useState('');
  const [error, setError] = useState('');

  const open = (e) => {
    e.preventDefault();
    const token = link.trim().split(/[/?#]/).filter(Boolean).pop();
    if (!token || token.length < 10) { setError('Paste the full link you were sent.'); return; }
    navigate(`/invite/${encodeURIComponent(token)}`);
  };

  return (
    <AuthShell variant="split">
      <AuthSplit>
        <AuthSplit.Brief
          sectionLabel="Access"
          headline="Built for security teams,"
          emphasis="onboarded with care."
          briefTitle="What your Inbox shows · Sample"
          rows={SAMPLE_ROWS}
          quote="Each organization is set up with a detailed profile, so briefs match the sector, region and technology you actually run."
        />
        <AuthSplit.Panel backTo="/">
          <div className="auth-head">
            <div className="auth-eyebrow">Request access</div>
            <h1 className="auth-title">Access is by <em>invitation.</em></h1>
            <p className="auth-intro" data-testid="access-info-copy">
              IntelliSecure does not have public sign-up. Your IntelliSecure account representative creates your organization,
              records its profile, and sends you a one-time link to choose your password.
            </p>
          </div>

          <form onSubmit={open} className="auth-form" noValidate>
            <AuthField id="invite_link" label="Have an invite link?" error={error || undefined} hint="Paste it here, or just open the link from your email.">
              <AuthInput id="invite_link" name="invite_link" data-testid="invite-link-input" autoComplete="off" spellCheck={false}
                         placeholder="https://…/invite/…" value={link} invalid={Boolean(error)}
                         onChange={(e) => { setLink(e.target.value); setError(''); }} />
            </AuthField>
            <AuthSubmit data-testid="invite-link-submit" loading={false} loadingLabel="Opening…" disabled={!link.trim()}>
              Open my invitation
              <ArrowRight aria-hidden="true" />
            </AuthSubmit>
          </form>

          <div className="auth-switch">
            <span>Already have an account?</span>
            <Link to="/login" className="auth-link">Sign in <ArrowRight size={12} aria-hidden="true" /></Link>
          </div>
        </AuthSplit.Panel>
      </AuthSplit>
    </AuthShell>
  );
}
